const burger = () => {
	const menuBtn = document.querySelector(".menu-btn");
	const mobileMenu = document.querySelector(".nav__menu--mobile-menu");

	let menuOpen = false;
	menuBtn.addEventListener("click", () => {
		if (!menuOpen) {
			menuBtn.classList.add("open");
			menuOpen = true;

			mobileMenu.classList.add("active");
		} else {
			menuBtn.classList.remove("open");
			menuOpen = false;
			mobileMenu.classList.remove("active");
		}
	});

	//user menu dropdown
	const userMenuToggle = document.querySelector(".user-menu__toggle--js");
	const userMenuDropdown = document.querySelector(".user-menu__dropdown--js");
	const userMenuList = document.querySelector(".user-menu__list--dropdown");

	// userMenuToggle.addEventListener("click", () => {
	// 	userMenuDropdown.classList.toggle("dropdown-open");
	// 	// userMenuDropdown.style.height = "fit-content";
	// });
};

export default burger;
